import {
  Swiper,
  SwiperOptions,
  Navigation,
  Thumbs,
  EffectFade,
  Pagination,
  Scrollbar,
} from 'swiper';
import SliderInterface from './interfaces/SliderInterface';
import 'swiper/css/bundle';

export default class Slider {
  static selectorDefault = '.js-sliderMenu';

  static optionsDefault: SwiperOptions = {
    modules: [Navigation, Thumbs, Pagination, Scrollbar],
    slidesPerView: 1,
    wrapperClass: 'c-slider__wrapper',
    slideClass: 'c-slider__slide',
    slideActiveClass: 'c-slider__slide--active',
  };

  static optionsThumbs: SwiperOptions = {
    modules: [EffectFade],
    slidesPerView: 1,
    spaceBetween: 15,
    effect: 'fade',
    allowTouchMove: false,
    watchSlidesProgress: true,
    wrapperClass: 'c-sliderTendance__wrapper',
    slideClass: 'c-sliderTendance__content',
    slideActiveClass: 'c-sliderTendance__content--active',
  };

  private selectorSlider: string;

  private sliderOptions: SwiperOptions;

  constructor(sliderConfig: SliderInterface) {
    const { selector, options } = sliderConfig;
    const selectorElt = Slider.sliderSelector(selector);
    this.selectorSlider = `${selectorElt} .c-slider__container`;
    const selectorThumbs = sliderConfig.selectorThumbs
      ? sliderConfig.selectorThumbs
      : null;

    if (selectorElt === '.js-slider') {
      this.selectorSlider = selectorElt;
    }

    this.sliderOptions = Slider.sliderOptions(
      selectorElt,
      options,
      selectorThumbs
    );
  }

  /*
   * Create slider Swiper
   * */
  public create(): undefined | Swiper {
    const selectorSliderDom = document.querySelector(this.selectorSlider);

    if (
      !selectorSliderDom ||
      (selectorSliderDom && selectorSliderDom.classList.contains('processed'))
    ) {
      return;
    }

    selectorSliderDom.classList.add('processed');

    // init Swiper:
    return new Swiper(this.selectorSlider, this.sliderOptions);
  }

  /*
   * Merge default config and new config
   * */
  private static sliderSelector(selector: string): string {
    return selector || Slider.selectorDefault;
  }

  /*
   * Merge default options and new options
   * */
  private static sliderOptions(
    selector: string,
    options: SwiperOptions,
    selectorThumbs: string | null = null
  ): SwiperOptions {
    let optionsThumbs = {};
    let next = '.c-slider__button--next';
    let prev = '.c-slider__button--prev';

    if (selector === '.js-slider') {
      next = '.js-slider__button--next';
      prev = '.js-slider__button--prev';
    }

    const optionsNavigation = {
      navigation: {
        nextEl: `${selector} ${next}`,
        prevEl: `${selector} ${prev}`,
        disabledClass: 'c-slider__button--disabled',
        hiddenClass: 'c-slider__button--hidden',
        lockClass: 'c-slider__button--lock',
      },
    };

    // Link a new swiper for thumbs
    if (selectorThumbs) {
      const swiperThumbs: Swiper = new Swiper(
        selectorThumbs,
        Slider.optionsThumbs
      );

      // sliderOptions.thumbs.swiper = swiperThumbs;
      optionsThumbs = {
        thumbs: {
          swiper: swiperThumbs,
        },
      };
    }

    return {
      ...Slider.optionsDefault,
      ...options,
      ...optionsNavigation,
      ...optionsThumbs,
    };
  }

  /*
   * Add overlay left and right to slider
   * */
  public static slideChangeTransitionStart(overlay: {
    containerSlider: HTMLElement;
    nextSlide: HTMLElement;
    currentSlide: HTMLElement;
    lastSecondSlideIndex: HTMLElement;
    secondSlideIndex: HTMLElement;
  }): void {
    overlay.containerSlider.classList.remove('c-slider__container--left');
    overlay.containerSlider.classList.remove('c-slider__container--right');

    if (
      overlay.nextSlide &&
      overlay.currentSlide.dataset.index >=
        overlay.secondSlideIndex.dataset.index
    ) {
      overlay.containerSlider.classList.add('c-slider__container--left');
    }
    if (
      overlay.nextSlide &&
      overlay.nextSlide.dataset.index ===
        overlay.lastSecondSlideIndex.dataset.index
    ) {
      overlay.containerSlider.classList.add('c-slider__container--right');
    }
  }
}
